import React, { useState } from "react";
import { Button, Card, CardHeader } from "reactstrap";
import { useRole } from "../../../redux/slices/authSlice";
import WithdrawalChargeBack from "./WithdrawalChargeBack";
import DepositChargeBack from "./DepositChargeBack";

const ChargeBack = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [sharedFilter, setSharedFilter] = useState({});
  const role = useRole("Deposit");
  const tabsData = [
    ...(role.includes("deposit-is-charge-back")
      ? [{ title: "Deposit", component: DepositChargeBack }]
      : []),
    ...(role.includes("deposit-is-charge-back")
      ? [{ title: "Withdrawal", component: WithdrawalChargeBack }]
      : []),
  ];

  const Component = tabsData?.[currentTab]?.component;

  if (!role.includes("deposit-is-charge-back")) {
    return;
  }

  return (
    <div>
      <Card>
        <CardHeader className="flex-column  align-items-start">
          <div className="d-flex align-items-center w-100 justify-content-between">
            <div>
              <h4 className="main-title">
                <b>Charge Back</b>
              </h4>
            </div>
            <div
              className="d-flex my-xl-auto right-content align-items-end button-space"
              style={{ flexWrap: "wrap" }}
            >
              {tabsData?.map?.((tab, index) => {
                return (
                  <Button
                    className={
                      currentTab === index ? "btn-primary" : "filterbtn"
                    }
                    color={currentTab === index ? "btn-primary" : ""}
                    onClick={() => {
                      setCurrentTab(index);
                      setSharedFilter({})
                    }}
                  >
                    {tab?.title}
                  </Button>
                );
              })}
            </div>
          </div>
        </CardHeader>
      </Card>
      <Component
        setSharedFilter={setSharedFilter}
        sharedFilter={sharedFilter}
        setCurrentTab={setCurrentTab}
      />
    </div>
  );
};

export default ChargeBack;
